import { baseSchema, Update } from './base'
import { generate } from './generate'
import { z } from 'zod'

export const bookmarkSchema = baseSchema.extend({
  repoId: z.string(),
  createdAt: z.string(),
  teamId: z.string(),
})

export type Bookmark = z.infer<typeof bookmarkSchema>
export type BookmarkUpdate = Update<Bookmark>

export const bookmarkBaseOps = generate('bookmark', bookmarkSchema.parse)
